import React, { useMemo, useRef, useState } from "react";
import { apiClient, useApiClient } from "../../../shared/customHooks";
import BaseApplicationComponent from "../baseApplicationComponent/BaseApplicationComponent";
import { applicationChecklistForm, ChecklistEmailStatus } from "../../../shared/formObjects/application/applicationChecklistForm";
import { Modal, ModalRef } from "../../modal/modal";
import { useApplicationContext } from "../context/applicationContext";
import { renderToStaticMarkup } from "react-dom/server";
import { Field, FormGroup } from "../../form";

function ApplicationChecklistComponent({ disabled, data, index }: any) {
  const { fetchData, postData, putData } = useApiClient(`ApplicationChecklists`);
  const [rest, setRest] = useState<any>({});
  const { id } = useApplicationContext();

  const [currentData, setcCurrentData] = useState<any>(null);

  const api: apiClient = useMemo(
    () => ({
      fetchData: async (route?: string, params?: any) =>
        await fetchData(route, params).then((res) => {
          setRest(res.data);
          res.data = res.data.checklists[0];
          return res;
        }),
      putData: async (formData: any, route?: string) => {
        const restData = { ...rest };
        restData.checklists[0] = formData;
        return await putData(restData, route);
      },
      postData,
    }),
    [rest]
  );
  const modalRef = useRef<ModalRef | null>(null);

  function triggerModal(newData: any) {
    setcCurrentData(newData);
    modalRef.current?.toggle();
  }

  const [newForm, setNewForm] = useState(true);

  function getInitalValues(initialData: any, setValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void) {
    setNewForm(initialData.emailStatus != ChecklistEmailStatus.NoEmailSent);
    const today = new Date();
    const oneWeek = new Date();
    oneWeek.setDate(today.getDate() + 7);
    switch (initialData.emailStatus) {
      case ChecklistEmailStatus.NoEmailSent:
        if (initialData.firstEmailDueDate == null) setValue("firstEmailDueDate", oneWeek);
        break;
      case ChecklistEmailStatus.InitialEmail:
        if (initialData.firstReminderEmailDueDate == null) setValue("firstReminderEmailDueDate", oneWeek);
        break;
      case ChecklistEmailStatus.FirstReminder:
        if (initialData.finalReminderEmailDueDate == null) setValue("finalReminderEmailDueDate", oneWeek);
        break;
      default:
        break;
    }
  }

  function confirmEmail() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const htmlString = renderToStaticMarkup(<>{list}</>);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function createNewChecklist() {
    postData(null, `addChecklist/${id}`);
  }

  const form = useMemo(() => {
    return applicationChecklistForm(triggerModal);
  }, [modalRef.current]);

  const d = useMemo(() => {
    if (data == undefined) return undefined;
    return data[index];
  }, [data, index]);

  function traverse(fg: FormGroup, d: any, list: React.JSX.Element[]) {
    fg.fields.forEach((f) => {
      if (f.type == "formGroup") {
        traverse(f as FormGroup, d, list);
      } else {
        const curr = f as Field;
        switch (curr.fieldType) {
          case "checkbox":
            if (d[curr.key] == true) {
              list.push(<b key={curr.key}>{curr.label}</b>);
            }
            break;
          case "textarea":
            if (d[curr.key] != null && d[curr.key].trim().length > 0 && !d[curr.key + "Hidden"]) {
              if (curr.key == "summary") {
                list.push(<h3 key={curr.key}>Summary</h3>);
              }
              list.push(
                <p key={curr.key} style={{ paddingLeft: "1em" }}>
                  {d[curr.key]}
                </p>
              );
            }
            break;
        }
      }
    });
    return list;
  }

  const list = useMemo<React.JSX.Element[]>(() => {
    const list: React.JSX.Element[] = [];
    if (currentData == null) return list;
    return traverse(form, currentData, list);
  }, [form, currentData]);

  return (
    <>
      {" "}
      <div className="flex flex-column align-items-start w-full pb-2">
        <BaseApplicationComponent
          formBody={form}
          headerLabel="Application Checklist"
          editPath="applicationchecklist"
          submitBtnTitle={newForm ? "Save" : "Create New Checklist"}
          customSubmit={newForm ? undefined : createNewChecklist}
          apiClient={api}
          disabled={disabled}
          data={d}
          showEdit={index == 0}
          getInitialValues={getInitalValues}
        />
      </div>
      <Modal ref={modalRef} confirmAction={confirmEmail} headerLabel="Submit & Send Email" confirmLabel="Submit & Send Email">
        <div>
          <p>
            If you submit this form, the system will update the status of this application and send an email to the kindergarten requesting the
            following items on the checklist are addressed:
          </p>
          <div style={{ textAlign: "left", padding: "1em" }}>{list}</div>
        </div>
      </Modal>
    </>
  );
}

export default ApplicationChecklistComponent;
